var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media video"},[_c('div',{staticClass:"video-wrapper"},[_c('vue-plyr',{ref:"plyr_video"},[_c('div',{staticClass:"plyr__video-embed"},[_c('iframe',{attrs:{"src":_vm.url,"allowfullscreen":"","allowtransparency":"","allow":"autoplay"}})])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }